import { ApiError } from "src/core";
import { ConfigD as configDClient } from "src/gen/rest/configd/ConfigDService";
import { LatchState } from "src/gen/schema/assertions/assertion_types";
import { Empty } from "src/gen/schema/common/empty";
import {
  BomItem,
  ClaimDevicesRequest,
  ClaimDevicesResponse,
  CommitDciCandidateRequest,
  CommitFabricCandidateRequest,
  CommitFabricCandidateResponse,
  CreateFabricBomEstimateRequest,
  DciCandidate,
  ExportedFabricConfiguration,
  ExportFabricConfigurationRequest,
  FabricCandidate,
  FabricConfig,
  GetBgpPeersRequest,
  GetCableModelsRequest,
  GetCableModelsResponse,
  GetDciCandidatesRequest,
  GetDciCandidatesResponse,
  GetDciConfigsRequest,
  GetDciConfigsResponse,
  GetDeviceModelsRequest,
  GetDeviceModelsResponse,
  GetDevicePsuModelsRequest,
  GetDevicePsuModelsResponse,
  GetDhcpRelaysRequest,
  GetDscpConfigsRequest,
  GetFabricAssemblyRequest,
  GetFabricAssemblyResponse,
  GetFabricBomEstimatesRequest,
  GetFabricBomEstimatesResponse,
  GetFabricBomForEstimateRequest,
  GetFabricBomRequest,
  GetFabricBomResponse,
  GetFabricCandidatesRequest,
  GetFabricCandidatesResponse,
  GetFabricConfigRequest,
  GetFabricConfigResponse,
  GetFabricDesignRequest,
  GetFabricDesignResponse,
  GetFabricInventoriesRequest,
  GetFabricInventoriesResponse,
  GetFabricMultisitesRequest,
  GetFabricMultisitesResponse,
  GetFabricsFilters,
  GetFabricsRequest,
  GetFabricsResponse,
  GetIpSlaConfigsRequest,
  GetLimitsRequest,
  GetLimitsResponse,
  GetNodesFilters,
  GetNodesPortsRequest,
  GetNodesPortsResponse,
  GetNodesRequest,
  GetNodesResponse,
  GetPacketMirroringsRequest,
  GetPortBreakoutsRequest,
  GetPortBreakoutsResponse,
  GetPortChannelsRequest,
  GetStaticRoutesRequest,
  GetSubInterfacesRequest,
  GetVnisRequest,
  GetVrfsRequest,
  ImportFabricResponse,
  ProvisionRequest,
  ProvisionResponse,
  RevertDciCandidateRequest,
  RevertFabricCandidateRequest,
  ReviewFabricCandidateRequest,
  ReviewFabricCandidateResponse,
  TenantsObjectsResponse,
  UnclaimDeviceRequest
} from "src/gen/schema/configd/api";
import {
  Assertion,
  AssertionsResponse,
  LatchAssertionsRequest
} from "src/gen/schema/configd/assertions";
import {
  AddOrgCertificatesRequest,
  AddOrgCertificatesResponse,
  DeleteOrgCertificateRequest,
  GetOrgCertificatesRequest,
  GetOrgCertificatesResponse
} from "src/gen/schema/configd/certificates";
import {
  AddDashboardsRequest,
  AddFoldersRequest,
  AddPanelsRequest,
  Dashboard,
  DashboardFolder,
  DashboardFoldersResponse,
  DashboardPanel,
  DashboardPanels,
  DashboardsResponse,
  DeleteDashboardRequest,
  DeletePanelRequest,
  GetDashboardsRequest,
  GetFoldersRequest,
  GetPanelRequest,
  GetPanelsRequest,
  UpdateDashboardRequest,
  UpdatePanelRequest
} from "src/gen/schema/configd/dashboard";
import {
  AddEndpointsRequest,
  DeleteEndpointRequest,
  EndpointsResponse,
  GetEndpointsRequest,
  GetNotificationSettingsRequest,
  NotificationSettingsResponse,
  ResendCodeForEndpointRequest,
  SetNotificationSettingsRequest,
  UpdateEndpointRequest,
  VerifyEndpointCode,
  VerifyEndpointRequest
} from "src/gen/schema/configd/endpoints";
import {
  GetEntitlementUsageRequest,
  GetEntitlementUsageResponse
} from "src/gen/schema/configd/entitlement";
import {
  AddSwitchGroupSoftwareConfigRequest,
  DeleteFabricTargetImageRequest,
  GetFabricSoftwareConfigRequest,
  GetOpticsFirmwareUpdateInfoRequest,
  UpdateFabricSoftwareModeRequest,
  UpdateFabricSoftwareNodeImagesRequest,
  UpdateFabricSoftwareRunningImageRequest,
  UpdateFabricSoftwareTargetImageRequest,
  UpdateSwitchGroupSoftwareTargetImageRequest,
  UpgradeOpticsFirmwareRequest
} from "src/gen/schema/configd/image";
import {
  AddManagementPortsRequest,
  GetManagementPortsRequest,
  ManagementPortsResponse,
  UpdateManagementPortRequest
} from "src/gen/schema/configd/node";
import {
  FabricBgpPoliciesResponse,
  GetFabricBgpPoliciesRequest
} from "src/gen/schema/configd/rest_bgp";
import {
  AddFabricWithDesignRequest,
  AddFabricWithDesignResponse,
  CloneFabricRequest,
  CloneFabricResponse,
  CreateFabricRevisionExportRequest,
  ExportedFabricRevision,
  Fabric as FabricGroup,
  FabricRevisionIdResponse,
  GenerateCablingPlanRequest,
  GenerateCablingPlanResponse,
  GetCablingPlanRequest,
  GetCablingPlanResponse,
  GetFabricRevisionIdRequest,
  GetFabricStpRequest,
  GetFabricTemplateRequest,
  GetFabricTemplateResponse,
  GetFabricTemplatesRequest,
  GetFabricTemplatesResponse,
  RestoreFabricRevisionRequest,
  RestoreFabricRevisionResponse,
  UpdateFabricWithDesignRequest
} from "src/gen/schema/configd/rest_fabrics";
import {
  FabricStaticRoutesResponse,
  FabricVnisResponse,
  FabricVrfsResponse,
  GetFabricStaticRoutesRequest,
  GetFabricVnisRequest,
  GetFabricVrfsRequest
} from "src/gen/schema/configd/rest_networks";
import {
  GetQueuedTaskRequest,
  QueuedTask
} from "src/gen/schema/configd/rest_queued_tasks";
import { CableModel, DeviceModel, DevicePSu } from "src/gen/schema/models/bom";
import { Panel } from "src/gen/schema/models/dashboard";
import {
  Endpoint,
  EndpointType,
  NotificationSettings
} from "src/gen/schema/models/endpoints";
import {
  CableType,
  FabricTopology,
  SoftwareMode
} from "src/gen/schema/models/fabric";
import { FabricDesign } from "src/gen/schema/models/fabric_design";
import { EntitlementUsageType } from "src/gen/schema/models/global";
import {
  FabricImageUpdate,
  FabricSoftwareConfig,
  NodeImageUpdate,
  SwitchGroupImageUpdate,
  SwitchGroupSoftwareConfig
} from "src/gen/schema/models/image";
import {
  DhcpRelay,
  Fabric,
  ManagementPort,
  Node,
  PortBreakout,
  PortChannel,
  StaticRoutes,
  SubInterface,
  Vni,
  Vrf
} from "src/gen/schema/models/models";
import { IpSlaConfig, PacketMirroring } from "src/gen/schema/models/qos";
import { BgpPeer, BgpPolicy, PerVlanStp } from "src/gen/schema/models/routing";
import { Certificates } from "src/gen/schema/models/types";
import {
  CreateRefPointRequest,
  RefPoint,
  RefPointByFabricRequest,
  RefPointByNameRequest
} from "src/gen/schema/refpoints/refpoints";
import { PathId } from "src/gen/schema/schema_path/path_id";

export const KEY_NAME = "running-mode";
export const CANDIDATE_NAME = "default";

export enum CandidateMode {
  Edit = "default",
  Running = "running"
}

export const ConfigD = {
  getFabricConfig: (
    candidate: string,
    fabricId: string,
    noTenants: boolean | undefined = false,
    options?: RequestInit | undefined
  ): Promise<FabricConfig | undefined> => {
    return configDClient
      .getFabricConfig(
        GetFabricConfigRequest.create({
          candidate,
          fabricId,
          noTenants
        }),
        options
      )
      .then((resp: GetFabricConfigResponse) => {
        return resp.config;
      });
  },
  getFabricDesign: (
    candidate: string,
    fabricId: string
  ): Promise<FabricDesign | undefined> => {
    const req = GetFabricDesignRequest.create({ candidate, fabricId });
    return configDClient
      .getFabricDesigns(req)
      .then((resp: GetFabricDesignResponse) => resp.design);
  },
  getCableModels: (
    modelNames: string[] = [],
    speeds: string[] = [],
    connectors: string[] = [],
    cableTypes: CableType[] = []
  ): Promise<CableModel[]> => {
    const req = GetCableModelsRequest.create({
      modelNames,
      speeds,
      connectors,
      cableTypes
    });
    return configDClient
      .getCableModels(req)
      .then((resp: GetCableModelsResponse) => {
        return resp.cables ?? [];
      });
  },
  getFabrics: (
    mode: CandidateMode,
    fabricIds: string[],
    filters: Partial<GetFabricsFilters> = {}
  ): Promise<Fabric[]> => {
    const fabricsRequest = GetFabricsRequest.create({
      filters: GetFabricsFilters.create({
        candidate: mode,
        fabricIds: fabricIds,
        ...filters
      })
    });
    return configDClient
      .getFabrics(fabricsRequest)
      .then((resp: GetFabricsResponse) => {
        return resp.fabrics ?? [];
      });
  },
  getFabricTransactions: (
    fabricId: string,
    filters: Partial<GetFabricCandidatesRequest> = {
      needInactive: false,
      needReviews: true,
      needEvents: true,
      name: ""
    },
    options?: RequestInit | undefined
  ): Promise<FabricCandidate[] | undefined> => {
    const req = GetFabricCandidatesRequest.create({
      fabricId: fabricId,
      ...filters
    });
    return configDClient
      .getFabricCandidates(req, options)
      .then((resp: GetFabricCandidatesResponse) => {
        return resp.candidates;
      });
  },
  getFabricInventory: (
    fabricId?: string,
    topology?: FabricTopology,
    nodeIds?: string[]
  ): Promise<Fabric[] | undefined> => {
    const req = GetFabricInventoriesRequest.create({
      fabricId,
      topology,
      nodeIds
    });
    return configDClient
      .getFabricInventories(req)
      .then((resp: GetFabricInventoriesResponse) => {
        return resp.fabrics ?? [];
      });
  },
  getConfigLimits: (): Promise<GetLimitsResponse> => {
    return configDClient.getLimits(
      GetLimitsRequest.create({ verifiedLimits: true })
    );
  },
  addManagementPort: (
    fabricId: string,
    nodeId: string,
    port: Partial<ManagementPort>
  ): Promise<ManagementPortsResponse> => {
    return configDClient.addManagementPorts(
      AddManagementPortsRequest.create({
        nodeId,
        fabricId,
        ports: [port]
      })
    );
  },
  updateManagementPort: (
    fabricId: string,
    nodeId: string,
    port: Partial<ManagementPort>
  ): Promise<ManagementPort> => {
    return configDClient.updateManagementPort(
      UpdateManagementPortRequest.create({
        id: port?.id,
        fabricId,
        nodeId,
        port
      })
    );
  },
  getSwitchPorts: (
    mode: CandidateMode,
    fabricId: string,
    filters: Partial<GetNodesPortsRequest>
  ): Promise<Node | undefined> => {
    const req = GetNodesPortsRequest.create({
      candidate: mode,
      fabricId,
      ...filters
    });
    return configDClient
      .getNodesPorts(req)
      .then((resp: GetNodesPortsResponse) => {
        return resp.nodes[0];
      });
  },
  getDeviceModels: (
    filters: Partial<GetDeviceModelsRequest> = {}
  ): Promise<DeviceModel[]> => {
    const req = GetDeviceModelsRequest.create({
      ...filters
    });
    return configDClient
      .getDeviceModels(req)
      .then((resp: GetDeviceModelsResponse) => {
        return resp.devices ?? [];
      });
  },
  getDevicePsuModels: (
    filters: Partial<GetDevicePsuModelsRequest> = {}
  ): Promise<DevicePSu[]> => {
    const req = GetDevicePsuModelsRequest.create({
      ...filters
    });
    return configDClient
      .getDevicePsuModels(req)
      .then((resp: GetDevicePsuModelsResponse) => {
        return resp.devicePsus ?? [];
      });
  },
  getPerVlanStpRequest: (
    mode: CandidateMode,
    fabricId: string
  ): Promise<PerVlanStp> => {
    const req = GetFabricStpRequest.create({
      candidate: mode,
      fabricId
    });
    return configDClient.getFabricStp(req);
  },
  getVnis: (
    mode: CandidateMode,
    fabricId: string,
    filters: Partial<GetVnisRequest> = {}
  ): Promise<Vni[]> => {
    const vniIds: string[] = [
      ...(Array.isArray(filters.ids) && filters.ids.length ? filters.ids : []),
      ...(Array.isArray(filters.names) && filters.names.length
        ? filters.names
        : []),
      ...(Array.isArray(filters.vnis) && filters.vnis.length
        ? filters.vnis.map(String)
        : [])
    ];
    const req = GetFabricVnisRequest.create({
      fabricId: fabricId,
      candidate: mode,
      vniId: vniIds
    });

    return configDClient.getFabricVnis(req).then((resp: FabricVnisResponse) => {
      return resp.vnis || [];
    });
  },
  getDHCPRelays: (
    mode: CandidateMode,
    fabricId: string,
    filters: Partial<GetDhcpRelaysRequest> = {}
  ): Promise<DhcpRelay[]> => {
    const req = GetDhcpRelaysRequest.create({
      fabricId: fabricId,
      candidate: mode,
      ...filters
    });
    return configDClient
      .getDhcpRelays(req)
      .then((resp: TenantsObjectsResponse) => {
        if (resp.tenants[0]) {
          return resp.tenants[0].dhcpRelays;
        }
        return [];
      });
  },
  getVRFs: (
    mode: CandidateMode,
    fabricId?: string,
    filters: Partial<GetVrfsRequest> = {},
    signal?: AbortSignal
  ): Promise<Vrf[]> => {
    const req = GetFabricVrfsRequest.create({
      candidate: mode,
      fabricId: fabricId,
      vrfId: filters.ids,
      needIps: filters.needIps,
      ipv4Address: filters.ipv4Addresses,
      ipv6Address: filters.ipv6Addresses
    });
    return configDClient
      .getFabricVrfs(req, { signal })
      .then((resp: FabricVrfsResponse) => {
        return resp.vrfs || [];
      });
  },
  getStaticRoutes: (
    mode: CandidateMode,
    fabricId?: string,
    filters: Partial<GetStaticRoutesRequest> = {}
  ): Promise<StaticRoutes[]> => {
    const req = GetFabricStaticRoutesRequest.create({
      candidate: mode,
      fabricId: fabricId,
      vrfId: filters?.vrfIds?.[0]
    });

    return configDClient
      .getFabricStaticRoutes(req)
      .then((resp: FabricStaticRoutesResponse) => {
        return resp.staticRoutes;
      });
  },
  getPortChannels: (
    mode: CandidateMode,
    fabricId: string,
    filters: Partial<GetPortChannelsRequest> = {}
  ): Promise<PortChannel[]> => {
    const req = GetPortChannelsRequest.create({
      fabricId: fabricId,
      candidate: mode,
      ...filters
    });
    return configDClient
      .getPortChannels(req)
      .then(
        (resp: TenantsObjectsResponse) => resp.tenants[0]?.portChannels ?? []
      );
  },
  getBgpPeers: (
    mode: CandidateMode,
    fabricId: string,
    filters: Partial<GetBgpPeersRequest> = {}
  ): Promise<BgpPeer[]> => {
    const req = GetBgpPeersRequest.create({
      candidate: mode,
      fabricId,
      ...filters
    });
    return configDClient
      .getBgpPeers(req)
      .then((resp: TenantsObjectsResponse) => {
        if (resp.tenants[0]) {
          return resp.tenants[0].bgpPeers;
        }
        return [];
      });
  },
  getBgpPolicies: (
    mode: CandidateMode,
    fabricId: string
  ): Promise<BgpPolicy[]> => {
    const req = GetFabricBgpPoliciesRequest.create({
      candidate: mode,
      fabricId
    });
    return configDClient
      .getFabricBgpPolicies(req)
      .then((resp: FabricBgpPoliciesResponse) => {
        return resp.policies;
      });
  },
  getIpSlaConfigs: (
    mode: CandidateMode,
    fabricId: string,
    filters: Partial<GetIpSlaConfigsRequest> = {}
  ): Promise<IpSlaConfig[]> => {
    const req = GetIpSlaConfigsRequest.create({
      candidate: mode,
      fabricId,
      ...filters
    });
    return configDClient
      .getIpSlaConfigs(req)
      .then((resp) => resp.tenants[0]?.ipSlaConfigs ?? []);
  },
  getPacketMirrorings: (
    mode: CandidateMode,
    fabricId: string,
    filters: Partial<GetPacketMirroringsRequest> = {}
  ): Promise<PacketMirroring[]> => {
    const req = GetPacketMirroringsRequest.create({
      candidate: mode,
      fabricId,
      ...filters
    });
    return configDClient
      .getPacketMirrorings(req)
      .then((resp) => resp.tenants[0]?.packetMirrorings ?? []);
  },
  getSubInterfaces: (
    mode: CandidateMode,
    nodeIds?: string[],
    filters: Partial<GetSubInterfacesRequest> = {},
    signal?: AbortSignal
  ): Promise<SubInterface[]> => {
    const req = GetSubInterfacesRequest.create({
      candidate: mode,
      nodeIds,
      ...filters
    });
    return configDClient
      .getSubInterfaces(req, { signal })
      .then((resp: TenantsObjectsResponse) => {
        if (resp.tenants[0]) {
          return resp.tenants[0].subInterfaces;
        }
        return [];
      });
  },
  getPortBreakouts: (
    filters: Partial<GetPortBreakoutsRequest> = {}
  ): Promise<PortBreakout[]> => {
    const req = GetPortBreakoutsRequest.create({
      ...filters
    });
    return configDClient
      .getPortBreakouts(req)
      .then((resp: GetPortBreakoutsResponse) => {
        if (resp.breakouts) {
          return resp.breakouts;
        }
        return [];
      });
  },
  getManagementPort: (
    fabricId: string,
    nodeId: string
  ): Promise<ManagementPort[]> => {
    const req = GetManagementPortsRequest.create({
      fabricId,
      nodeId
    });
    return configDClient
      .getManagementPorts(req)
      .then((resp: ManagementPortsResponse) => {
        return resp.ports;
      });
  },
  getFabricBOM: (
    mode: CandidateMode,
    fabricId?: string
  ): Promise<GetFabricBomResponse> => {
    const req = GetFabricBomRequest.create({
      candidate: mode,
      fabricId: fabricId
    });
    return configDClient
      .getFabricBom(req)
      .then((resp: GetFabricBomResponse) => {
        return resp;
      });
  },
  getFabricAssembly: (
    mode: CandidateMode,
    fabricId?: string
  ): Promise<GetFabricAssemblyResponse> => {
    const req = GetFabricAssemblyRequest.create({
      candidate: mode,
      fabricId: fabricId
    });
    return configDClient
      .getFabricAssembly(req)
      .then((resp: GetFabricAssemblyResponse) => {
        return resp;
      });
  },
  getOrgCertificates: (
    ids: string[] = [],
    names: string[] = []
  ): Promise<GetOrgCertificatesResponse> => {
    const req = GetOrgCertificatesRequest.create({
      ids,
      names
    });
    return configDClient.getOrgCertificates(req);
  },
  getFabricTemplates: (
    req: Partial<GetFabricTemplatesRequest>
  ): Promise<GetFabricTemplatesResponse> => {
    return configDClient.getFabricTemplates(
      GetFabricTemplatesRequest.create(req)
    );
  },
  getTemplateDetail: (
    req: Partial<GetFabricTemplateRequest>
  ): Promise<GetFabricTemplateResponse> => {
    return configDClient.getFabricTemplate(
      GetFabricTemplateRequest.create(req)
    );
  },
  getCablingPlan: (
    mode: CandidateMode,
    req: Partial<GetCablingPlanRequest>
  ): Promise<GetCablingPlanResponse> => {
    return configDClient.getCablingPlan(
      GetCablingPlanRequest.create({ ...req, candidate: mode })
    );
  },
  addOrgCertificates: (
    certificates: Partial<Certificates>[]
  ): Promise<Certificates[]> => {
    const req = AddOrgCertificatesRequest.create({
      certificates
    });
    return configDClient
      .addOrgCertificates(req)
      .then((res: AddOrgCertificatesResponse) => {
        return res.certificates || [];
      });
  },
  deleteOrgCertificates: (certificateId: string): Promise<Empty> => {
    const req = DeleteOrgCertificateRequest.create({
      certificateId
    });
    return configDClient.deleteOrgCertificate(req);
  },
  getFabricBomEstimation: (
    fabricId: string,
    candidate: string,
    createdBy: string,
    mainItems: BomItem[] | undefined
  ) => {
    const req = CreateFabricBomEstimateRequest.create({
      fabricId,
      createdBy,
      mainItems,
      candidate
    });
    return configDClient.createFabricBomEstimate(req);
  },
  getFabricBomEstimationHistory: (fabricId: string) => {
    const req = GetFabricBomEstimatesRequest.create({
      fabricId
    });
    return configDClient
      .getFabricBomEstimates(req)
      .then((resp: GetFabricBomEstimatesResponse) => {
        return resp?.estimates ?? [];
      });
  },
  getFabricBomForEstimate: (fabricId: string, estimateId: string) => {
    const req = GetFabricBomForEstimateRequest.create({
      fabricId,
      estimateId
    });
    return configDClient.getFabricBomForEstimate(req);
  },
  reviewFabricTransaction: (
    fabricId?: string,
    comments?: string
  ): Promise<boolean> => {
    const req = ReviewFabricCandidateRequest.create({
      fabricId,
      comments,
      name: "default"
    });
    return configDClient
      .reviewFabricCandidate(req)
      .then((resp: ReviewFabricCandidateResponse) => {
        return resp !== undefined;
      });
  },
  createRefPoint: (
    fabricId?: string,
    deviceIds?: string[]
  ): Promise<RefPoint> => {
    const req = CreateRefPointRequest.create({
      fabricId,
      deviceIds
    });
    return configDClient.createProvisionalRefPoint(req);
  },
  deleteRefPoint: (
    fabricId?: string,
    refPointName?: string
  ): Promise<Empty> => {
    const req = RefPointByNameRequest.create({
      fabricId,
      refPointName
    });
    return configDClient.deleteRefPoint(req);
  },
  promoteRefPoint: (fabricId?: string): Promise<RefPoint> => {
    const req = RefPointByFabricRequest.create({
      fabricId
    });
    return configDClient.promoteProvisionalRefPoint(req);
  },
  createRefPointDiff: (fabricId?: string): Promise<RefPoint> => {
    const req = RefPointByFabricRequest.create({
      fabricId
    });
    return configDClient.createRefPointDiff(req);
  },
  provision: (
    fabricId: string,
    req: ProvisionRequest,
    callback: ((response: ProvisionResponse) => void) | undefined,
    errorCallback: (err: ApiError) => void
  ): Promise<ProvisionResponse | ApiError> => {
    if (!req.fabricId) {
      req.fabricId = fabricId;
    }

    if (req.fabricId) {
      return configDClient
        .provisionUpdate(req)
        .then((resp) => {
          if (callback) {
            callback(resp);
          }
          return resp;
        })
        .catch((err: ApiError) => {
          errorCallback(err);
          return err;
        });
    }
    return configDClient
      .provisionCreate(req)
      .then((resp) => {
        if (callback) {
          callback(resp);
        }
        return resp;
      })
      .catch((err: ApiError) => {
        errorCallback(err);
        return err;
      });
  },
  commitFabricCandidate: (
    fabricId?: string,
    name?: string,
    comments?: string,
    mergeDci?: boolean
  ): Promise<CommitFabricCandidateResponse> => {
    return configDClient.commitFabricCandidate(
      CommitFabricCandidateRequest.create({
        fabricId,
        name: name || CANDIDATE_NAME,
        comments,
        mergeDci
      })
    );
  },
  revertFabricCandidate: (
    fabricId?: string,
    name?: string,
    comments?: string
  ): Promise<boolean> => {
    return configDClient
      .revertFabricCandidate(
        RevertFabricCandidateRequest.create({ fabricId, name, comments })
      )
      .then(() => {
        return true;
      })
      .catch(() => {
        return false;
      });
  },
  getNotificationSettings: (
    includeMetadata: boolean
  ): Promise<NotificationSettingsResponse> => {
    const req = GetNotificationSettingsRequest.create({
      includeMetadata
    });
    return configDClient
      .getNotificationSettings(req)
      .then((resp: NotificationSettingsResponse) => {
        return resp;
      });
  },
  setNotificationSettings: (
    settings: NotificationSettings[]
  ): Promise<Empty> => {
    const req = SetNotificationSettingsRequest.create({
      settings
    });
    return configDClient.setNotificationSettings(req);
  },
  getEndpoints: (
    type: EndpointType[],
    includeMetadata: boolean
  ): Promise<Endpoint[]> => {
    const req = GetEndpointsRequest.create({
      type,
      includeMetadata
    });
    return configDClient.getEndpoints(req).then((resp: EndpointsResponse) => {
      return resp.endpoints;
    });
  },
  addEndpoints: (
    endpoints: Partial<Endpoint>[],
    sendConfirmationCode: boolean
  ): Promise<EndpointsResponse> => {
    const req = AddEndpointsRequest.create({
      endpoints,
      sendConfirmationCode
    });
    return configDClient.addEndpoints(req);
  },
  updateEndpoint: (
    endpoint: Partial<UpdateEndpointRequest>
  ): Promise<Empty> => {
    const req = UpdateEndpointRequest.create(endpoint);
    return configDClient.updateEndpoint(req);
  },
  verifyEndpoint: (
    endpointId: string,
    code: VerifyEndpointCode | undefined
  ): Promise<Empty> => {
    const req = VerifyEndpointRequest.create({
      endpointId,
      code
    });
    return configDClient.verifyEndpoint(req);
  },
  resendCodeForEndpoint: (endpointId: string): Promise<Empty> => {
    const req = ResendCodeForEndpointRequest.create({ endpointId });
    return configDClient.resendCodeForEndpoint(req);
  },
  deleteEndpoint: (endpointId: string): Promise<Empty> => {
    const req = DeleteEndpointRequest.create({ endpointId });
    return configDClient.deleteEndpoint(req);
  },
  claimDevices: (claimCodes: string[]): Promise<ClaimDevicesResponse> => {
    const req = ClaimDevicesRequest.create({ claimCodes });
    return configDClient.claimDevices(req);
  },
  unclaimDevice: (deviceId: string): Promise<Empty> => {
    const req = UnclaimDeviceRequest.create({ deviceId });
    return configDClient.unclaimDevice(req);
  },
  claimDiscoveredDevices: (
    deviceIds: string[]
  ): Promise<ClaimDevicesResponse> => {
    const req = ClaimDevicesRequest.create({ deviceIds });
    return configDClient.claimDevices(req);
  },
  addFabricWithDesign: (
    fabric: FabricGroup,
    design: FabricDesign
  ): Promise<AddFabricWithDesignResponse> => {
    const req = AddFabricWithDesignRequest.create({
      fabric: fabric,
      design: design
    });
    return configDClient.addFabricWithDesign(req);
  },
  updateFabricWithDesign: (
    fabricId: string,
    fabric: FabricGroup,
    design: FabricDesign
  ): Promise<FabricGroup> => {
    const req = UpdateFabricWithDesignRequest.create({
      fabricId,
      fabric,
      design
    });
    return configDClient.updateFabricWithDesign(req);
  },
  generateCablingDryrun: (
    fabricId?: string,
    design?: FabricDesign,
    includeCablingPlan?: boolean,
    dryRun?: boolean,
    includeExceptions?: boolean
  ): Promise<GenerateCablingPlanResponse> => {
    const req = GenerateCablingPlanRequest.create({
      fabricId,
      design,
      includeCablingPlan,
      dryRun,
      includeExceptions
    });
    return configDClient.generateCablingPlanFromDesign(req);
  },
  generateCabling: (
    fabricId?: string,
    design?: FabricDesign,
    includeCablingPlan?: boolean,
    includeExceptions?: boolean
  ): Promise<GenerateCablingPlanResponse> => {
    const req = GenerateCablingPlanRequest.create({
      fabricId,
      design,
      includeCablingPlan,
      includeExceptions
    });
    return configDClient.generateCablingPlanForFabric(req);
  },
  importFabricConfiguration: (
    config: ExportedFabricConfiguration,
    renameAs?: string,
    passphrase?: string
  ): Promise<ImportFabricResponse> => {
    const req = ExportedFabricConfiguration.create({
      ...config,
      renameAs: renameAs || undefined,
      background: !passphrase,
      password: passphrase || undefined
    });
    return configDClient.importFabricConfiguration(req);
  },
  exportFabricConfiguration: (
    fabricId: string,
    candidate: string,
    passphrase?: string
  ): Promise<ExportedFabricConfiguration> => {
    const req = ExportFabricConfigurationRequest.create({
      fabricId,
      candidate,
      password: passphrase || undefined
    });
    return configDClient.exportFabricConfiguration(req);
  },
  getFabricSoftwareConfig: (
    fabricId: string,
    candidate: string
  ): Promise<FabricSoftwareConfig> => {
    const req = GetFabricSoftwareConfigRequest.create({
      fabricId,
      candidate
    });
    return configDClient.getFabricSoftwareConfig(req);
  },
  updateFabricSoftwareRunningImage: (
    fabricId: string,
    runningImage: FabricImageUpdate | undefined,
    softwareMode: SoftwareMode = SoftwareMode.SOFTWARE_MODE_UNSPECIFIED,
    skipDeviceReadinessCheck: boolean = false
  ): Promise<FabricSoftwareConfig> => {
    const req = UpdateFabricSoftwareRunningImageRequest.create({
      fabricId,
      runningImage,
      softwareMode,
      skipDeviceReadinessCheck
    });
    return configDClient.updateFabricSoftwareRunningImage(req);
  },
  updateFabricSoftwareTargetImage: (
    fabricId: string,
    targetImage: FabricImageUpdate | undefined
  ): Promise<FabricSoftwareConfig> => {
    const req = UpdateFabricSoftwareTargetImageRequest.create({
      fabricId,
      targetImage
    });
    return configDClient.updateFabricSoftwareTargetImage(req);
  },
  deleteFabricTargetImage: (fabricId: string): Promise<Empty> => {
    const req = DeleteFabricTargetImageRequest.create({
      fabricId
    });
    return configDClient.deleteFabricTargetImage(req);
  },
  updateFabricSoftwareNodeImages: (
    fabricId: string,
    nodeImages: NodeImageUpdate[]
  ): Promise<FabricSoftwareConfig> => {
    const req = UpdateFabricSoftwareNodeImagesRequest.create({
      fabricId,
      nodeImages
    });
    return configDClient.updateFabricSoftwareNodeImages(req);
  },
  updateFabricSoftwareMode(
    fabricId: string,
    softwareMode: SoftwareMode = SoftwareMode.SOFTWARE_MODE_UNSPECIFIED,
    skipDeviceReadinessCheck: boolean = false
  ): Promise<FabricSoftwareConfig> {
    const req = UpdateFabricSoftwareModeRequest.create({
      fabricId,
      softwareMode,
      skipDeviceReadinessCheck
    });
    return configDClient.updateFabricSoftwareMode(req);
  },
  getDscpConfigs(
    fabricId: string,
    candidate: string,
    defaultOnly: boolean
  ): Promise<TenantsObjectsResponse> {
    const req = GetDscpConfigsRequest.create({
      fabricId,
      candidate,
      defaultOnly
    });
    return configDClient.getDscpConfigs(req);
  },
  getEntitlementUsage: (
    nodes: boolean = false,
    usageType?: EntitlementUsageType
  ): Promise<GetEntitlementUsageResponse> => {
    const req = GetEntitlementUsageRequest.create({ nodes, usageType });
    return configDClient.getEntitlementUsage(req);
  },
  latchAssertions: (
    fabricId: string,
    state: LatchState,
    id: PathId
  ): Promise<Assertion[]> => {
    let updatedState = LatchState.LATCH_STATE_UNSPECIFIED;
    if (state === LatchState.UNLATCHED) {
      updatedState = LatchState.LATCHED;
    } else if (state === LatchState.LATCHED) {
      updatedState = LatchState.UNLATCHED;
    }
    const request = LatchAssertionsRequest.create({
      fabricId,
      assertions: [
        {
          id,
          state: updatedState
        }
      ]
    });
    return configDClient
      .latchAssertions(request)
      .then((resp: AssertionsResponse) => {
        return resp.assertions;
      });
  },
  migrateFabric: (
    fabricName: string,
    fabricId: string,
    topology: FabricTopology
  ): Promise<AddFabricWithDesignResponse> => {
    const now = new Date();
    const cleanTimeStamp = now.toISOString().replace(/[^0-9]/g, "");
    const req = AddFabricWithDesignRequest.create({
      fabric: {
        topology,
        name: `${fabricName} - new fabric clone - ${cleanTimeStamp}`
      },
      sourceFabricId: fabricId
    });
    return configDClient.addFabricWithDesign(req);
  },
  cloneFabric: (
    fabricId: string,
    cloneName: string
  ): Promise<CloneFabricResponse> => {
    const req = CloneFabricRequest.create({
      fabricId,
      cloneName,
      background: true
    });
    return configDClient.cloneFabric(req);
  },
  getFabric: (
    mode: CandidateMode,
    fabricId: string,
    filters: Partial<GetFabricsFilters> = { loadChildren: true }
  ): Promise<Fabric | undefined> => {
    return ConfigD.getFabrics(mode, [fabricId], filters).then(
      (fabrics: Fabric[]) => {
        return fabrics.find((f) => f.id === fabricId);
      }
    );
  },
  getMultisiteConfigs: (
    mode: CandidateMode,
    request: GetDciConfigsRequest
  ): Promise<GetDciConfigsResponse> => {
    const dciConfigsRequest = GetDciConfigsRequest.create({
      ...request,
      candidate: mode
    });
    return configDClient.getDciConfigs(dciConfigsRequest);
  },
  getFabricMultisites: (
    mode: CandidateMode,
    request: GetFabricMultisitesRequest
  ): Promise<GetFabricMultisitesResponse> => {
    const multiSiteConfigsRequest = GetFabricMultisitesRequest.create({
      ...request,
      candidate: mode
    });
    return configDClient.getFabricMultisites(multiSiteConfigsRequest);
  },
  getMultisiteTransactions: (
    dciId: string,
    filters: Partial<GetDciCandidatesRequest> = {
      needInactive: false,
      needReviews: true,
      needEvents: true,
      name: ""
    }
  ): Promise<DciCandidate[] | undefined> => {
    const req = GetDciCandidatesRequest.create({
      ...filters,
      dciId
    });
    return configDClient
      .getDciCandidates(req)
      .then((resp: GetDciCandidatesResponse) => {
        return resp.candidates;
      });
  },
  commitDciCandidate: (
    dciId: string,
    name: string,
    comments: string
  ): Promise<boolean> => {
    return configDClient
      .commitDciCandidate(
        CommitDciCandidateRequest.create({
          dciId,
          name: name || CANDIDATE_NAME,
          comments
        })
      )
      .then(() => {
        return true;
      });
  },
  revertDciCandidate: (
    dciId: string,
    name: string,
    comments: string
  ): Promise<boolean> => {
    return configDClient
      .revertDciCandidate(
        RevertDciCandidateRequest.create({
          dciId,
          name: name || CANDIDATE_NAME,
          comments
        })
      )
      .then(() => {
        return true;
      });
  },
  getSwitches: (
    mode: CandidateMode,
    fabricId: string
  ): Promise<Node[] | undefined> => {
    const filters = GetNodesFilters.create({
      candidate: mode,
      fabricId,
      loadChildren: true
    });
    return configDClient
      .getNodes(GetNodesRequest.create({ filters }))
      .then((resp: GetNodesResponse) => {
        return resp.nodes;
      });
  },
  getFabricRevisionId: (
    fabricId: string,
    committed?: boolean,
    max?: number,
    lookbackDuration?: string
  ): Promise<FabricRevisionIdResponse> => {
    const req = GetFabricRevisionIdRequest.create({
      fabricId,
      committed,
      max,
      lookbackDuration,
      sortDesc: true
    });
    return configDClient.getFabricRevisionId(req);
  },
  restoreFabricRevision: (
    fabricId: string,
    revisionId?: string,
    password?: string,
    revisionConfig?: ExportedFabricRevision
  ): Promise<RestoreFabricRevisionResponse> => {
    const req = RestoreFabricRevisionRequest.create({
      fabricId,
      revisionId,
      password,
      revisionConfig
    });
    return configDClient.restoreFabricRevision(req);
  },
  exportFabricRevision: (
    fabricId: string,
    revisionId: string,
    password?: string
  ): Promise<ExportedFabricRevision> => {
    const req = CreateFabricRevisionExportRequest.create({
      fabricId,
      revisionId,
      password
    });
    return configDClient.createFabricRevisionExport(req);
  },

  // Dashboards
  addFolder(
    fabricId: string,
    signal?: AbortSignal
  ): Promise<DashboardFoldersResponse> {
    const req = AddFoldersRequest.create({
      fabricId,
      folders: [DashboardFolder.fromPartial({ fabricId, name: "default" })] // we only use default folder for now
    });
    return configDClient.addFolders(req, { signal });
  },
  getFolders(
    fabricId: string,
    signal?: AbortSignal
  ): Promise<DashboardFoldersResponse> {
    const req = GetFoldersRequest.create({ fabricId });
    return configDClient.getFolders(req, { signal });
  },
  addDashboard(
    fabricId: string,
    folderId: string,
    name: string
  ): Promise<DashboardsResponse> {
    const req = AddDashboardsRequest.create({
      fabricId,
      folderId,
      dashboards: [Dashboard.fromPartial({ fabricId, folderId, name })]
    });
    return configDClient.addDashboards(req);
  },
  deleteDashboard(
    fabricId: string,
    folderId: string,
    dashboardId: string
  ): Promise<void> {
    const req = DeleteDashboardRequest.create({
      fabricId,
      folderId,
      dashboardId
    });
    return configDClient.deleteDashboard(req).then(() => {});
  },
  getDashboards(
    fabricId: string,
    folderId: string
  ): Promise<DashboardsResponse> {
    const req = GetDashboardsRequest.create({ fabricId, folderId });
    return configDClient.getDashboards(req);
  },
  updateDashboard(
    fabricId: string,
    folderId: string,
    dashboardId: string,
    partialDashboard: Partial<Dashboard>
  ): Promise<Dashboard> {
    const req = UpdateDashboardRequest.create({
      fabricId,
      folderId,
      dashboardId,
      dashboard: Dashboard.fromPartial(partialDashboard)
    });
    return configDClient.updateDashboard(req);
  },
  addPanel(
    fabricId: string,
    folderId: string,
    dashboardId: string,
    panel: Panel
  ): Promise<DashboardPanels> {
    const req = AddPanelsRequest.create({
      fabricId,
      folderId,
      dashboardId,
      panels: [panel]
    });
    return configDClient.addPanels(req);
  },
  getPanels(
    fabricId: string,
    folderId: string,
    dashboardId: string,
    includeMetadata?: boolean
  ): Promise<DashboardPanels> {
    const req = GetPanelsRequest.create({
      fabricId,
      folderId,
      dashboardId,
      includeMetadata
    });
    return configDClient.getPanels(req);
  },
  getPanel(
    fabricId: string,
    folderId: string,
    dashboardId: string,
    panelId: string,
    includeMetadata?: boolean
  ): Promise<DashboardPanel> {
    const req = GetPanelRequest.create({
      fabricId,
      folderId,
      dashboardId,
      panelId,
      includeMetadata
    });
    return configDClient.getPanel(req);
  },
  updatePanel(
    fabricId: string,
    folderId: string,
    dashboardId: string,
    panelId: string,
    partialPanel: Partial<Panel>
  ): Promise<DashboardPanel> {
    const req = UpdatePanelRequest.create({
      fabricId,
      folderId,
      dashboardId,
      panelId,
      panel: partialPanel
    });
    return configDClient.updatePanel(req);
  },
  deletePanel(
    fabricId: string,
    folderId: string,
    dashboardId: string,
    panelId: string
  ): Promise<void> {
    const req = DeletePanelRequest.create({
      fabricId,
      folderId,
      dashboardId,
      panelId
    });
    return configDClient.deletePanel(req).then(() => {});
  },
  addSwitchGroupSoftwareConfig(
    fabricId: string,
    switchGroupId: string,
    switchGroupSwConf: SwitchGroupSoftwareConfig | undefined
  ) {
    const request = AddSwitchGroupSoftwareConfigRequest.fromPartial({
      fabricId,
      switchGroupId,
      switchGroupSwConf
    });
    return configDClient.addSwitchGroupSoftwareConfig(request);
  },
  updateSwitchGroupSoftwareTargetImage(
    fabricId: string,
    switchGroupId: string,
    targetImage: SwitchGroupImageUpdate | undefined
  ) {
    const request = UpdateSwitchGroupSoftwareTargetImageRequest.fromPartial({
      fabricId,
      switchGroupId,
      targetImage
    });
    return configDClient.updateSwitchGroupSoftwareTargetImage(request);
  },
  getQueuedTask(taskId: string): Promise<QueuedTask> {
    const req = GetQueuedTaskRequest.create({ taskId });
    return configDClient.getQueuedTask(req);
  },
  getOpticsFirmwareUpdateInfo(
    fabricId: string,
    filters?: {
      opticsPids?: string[];
      opticsModels?: string[];
      switchGroups?: string[];
      nodePorts?: string[];
      upgradable?: boolean;
    }
  ) {
    const request = GetOpticsFirmwareUpdateInfoRequest.fromPartial({
      fabricId,
      ...filters
    });
    return configDClient.getOpticsFirmwareUpdateInfo(request);
  },
  upgradeOpticsFirmware(
    fabricId: string,
    request: {
      filters?: {
        opticsPid?: string;
        opticsModel?: string;
        switchGroups?: string[];
        nodePorts?: { nodeName: string; portNames: string[] }[];
      }[];
      active?: boolean;
    }
  ) {
    const upgradeRequest = UpgradeOpticsFirmwareRequest.fromPartial({
      fabricId,
      filters: request.filters || [],
      active: request.active || false
    });
    return configDClient.upgradeOpticsFirmware(upgradeRequest);
  }
};
